<div class="spen-page-content" [class.student-content]="authUserService.isStudent()">
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
